import clsx from "clsx";
import { Form } from "react-bootstrap";
import { RenderWhen } from "../../../../../components";
import TooltipIcon from "../../../../../components/TooltipIcon";
import Typography from "../../../../../components/typography/Typography";
import styles from "./reanalyze-text-input.module.scss";

interface ReanalyzeTextInputProps {
  value?: string | number;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  fieldLabel?: string;
  inputLabel?: string;
  type: "number" | "text";
  placeholder?: string;
  inputClassName?: string;
  tooltip?: string;
  error?: string;
}

const ReanalyzeTextInput = ({
  value,
  onChange,
  disabled,
  className,
  fieldLabel,
  inputLabel,
  type,
  placeholder,
  inputClassName,
  tooltip,
  error
}: ReanalyzeTextInputProps) => (
  <div
    className={clsx(
      "d-flex justify-content-start p-15 w-100 flex-grow-1 flex-gap-2",
      styles.reanalyze_text_container,
      {
        "background-color-disabled": disabled,
        "cursor-default": disabled
      },
      className
    )}
  >
    <div className="d-flex align-items-center flex-gap-2">
      <Typography
        variant={"subtitle6"}
        className={clsx(
          "text-color-gray-60 text-uppercase",
          styles.reanalyze_field_label
        )}
      >
        {fieldLabel}
      </Typography>
      {tooltip && (
        <TooltipIcon
          icon="info-circle"
          message={tooltip}
          data-testid="rlcs_configuration_info_tooltip_icon"
        />
      )}
    </div>
    <div className={"flex flex-gap-2 align-items-center"}>
      <Form.Control
        id={`reanalyze-text-input-${fieldLabel}`}
        type={"text"}
        value={disabled ? "" : value ?? ""}
        onChange={e => {
          if (type === "number") {
            if (e.target.value === "") {
              onChange("");
              return;
            }
            const numValue = parseInt(e.target.value, 10);
            if (isNaN(numValue) || numValue < 0) {
              return;
            }
          }
          onChange(e.target.value);
        }}
        disabled={disabled}
        placeholder={placeholder}
        className={clsx(inputClassName, styles.reanalyze_text_input)}
      />
      {inputLabel && (
        <Typography variant={"subtitle6"} className={"text-color-gray-60"}>
          {inputLabel}
        </Typography>
      )}
    </div>
    <RenderWhen condition={!!error}>
      <Typography
        variant={"body4"}
        tag={"span"}
        className={clsx("text-danger", styles.error_message)}
      >
        {error}
      </Typography>
    </RenderWhen>
  </div>
);

export default ReanalyzeTextInput;
